export default {"src":"/_next/static/media/unit_info.95085435.svg","height":44,"width":44};